import Vue from "vue";
export default {
  notificationAdd(state, notification) {
    const existingIndex = state.notifications.findIndex(
      ({ id }) => id === notification.id
    );
    if (existingIndex > -1) {
      Vue.set(state.notifications, existingIndex, notification);
    } else {
      state.notifications.push(notification);
    }
  },
  notificationDismiss(state, { indexToRemove }) {
    state.notifications.splice(indexToRemove, 1);
  }
};
